import { GameVars } from "../../GameVars";
import { PaginationButton } from "./PaginationButton";
import { ShopItemCapsule } from "./ShopItemCapsule";

export class ItemsContainer extends Phaser.GameObjects.Container {

    public currentPage: number;
    public totalPages: number;

    private containerType: string;
    private items: ShopItemCapsule[];
    private cols: number;
    private rows: number;
    
    constructor(scene: Phaser.Scene, containerType: string) {
        
        super(scene);

        this.containerType = containerType;
        this.items = [];

        this.setRowsAndColumns();

        let x: number;
        let y: number;
        let dx: number;
        let dy: number;
        let scale: number;

        if (this.cols === 2) {

            x = -160;
            
            dx = 320;

            if (GameVars.aspectRatio < 1.5) {
                scale = 1;
                y = 360;
                dy = 320;
            } else  if (GameVars.aspectRatio < 1.8) {
                scale = .775;
                y = 315;
                dy = 360;
            } else {
                scale = .85;
                y = 370;
                dy = 420;
            }

        } else {

            x = -220;
           
            dx = 220;
            scale = 1;

            if (GameVars.aspectRatio < 1.5) {
                y = 320;
                dy = 320;
            } else  if (GameVars.aspectRatio < 1.8) {
                y = 300;
                dy = 360;
            } else {
                y = 370;
                dy = 420;
            }
        }

        let item: ShopItemCapsule;
        let i = 1;
        let px = x;
        let py = y;

        for (let r = 0; r < this.rows; r ++) {

            for (let c = 0; c < this.cols; c ++) {

                item = new ShopItemCapsule(this.scene, containerType, i);
                item.x = px;
                item.y = py;
                item.setScale(scale);
                this.add(item);
    
                px += dx;
                i++;
    
                this.items.push(item);
            }

            px = x;
            py += dy;
        }
    }

    public updateItems(): void {
        
        for (let i = 0; i < this.items.length; i ++) {
            this.items[i].setStatus();
        }
    }

    public scroll(side: string): void {

        if (side === PaginationButton.RIGHT) {
            this.currentPage ++;
        } else {
            this.currentPage --;
        }
       
        const itemsPerPage = this.cols * this.rows;
     
        const i = (this.currentPage - 1) * itemsPerPage;

        for (let j = 0; j < this.items.length; j ++) {
            this.items[j].setStatus(i + j + 1);
        }
    }

    private setRowsAndColumns(): void {

        if (this.containerType === ShopItem.BOARD) {
            this.cols = 2;
            this.rows = GameVars.aspectRatio > 1.5 ? 2 : 1;
            this.totalPages = GameVars.aspectRatio > 1.5 ? 2 : 4;
        } else {
            this.cols = 3;
            this.rows = GameVars.aspectRatio > 1.5 ? 2 : 1;
            this.totalPages = GameVars.aspectRatio > 1.5 ? 2 : 4;
        }

        this.currentPage = 1;
    }
}
